import { feedbackCollector } from '../feedback-collector';

export const getSuggestionsFeedback = feedbackCollector({
  surveyName: 'Suggestions Feedback',
});
